/* PT · Contact page behaviour (spec-contact-page-4b).
   1. Ink band: the header sits inside it (pt-header.css keys that off [data-ct-band]); once
      the band has scrolled under the header, html.pt-ct-past returns it to the paper header,
      with the header's own ~250ms cross-fade. Also writes --pt-hdr-h so the band climbs
      exactly the header's height.
   2. Topic card: a tablist. Click or arrow keys switch topics; the new pane dissolves in
      over the old one (no movement, no dimming); all panes share one grid cell (CSS), so the box is always the tallest topic's height and nothing below ever moves.
   3. Scroll-in: .pt-ct-rv elements fade/rise once, staggered ~60ms.
   4. After the page has loaded, the photos below the fold are fetched in the background. */
(function () {
  "use strict";
  /* every Contact section includes this file; run it once for the whole page */
  if (window.__ptContact) return;
  window.__ptContact = true;
  var html = document.documentElement;

  /* ---------- 1 · ink band + header ---------- */
  var band = null, wrap = null, bound = false;
  function measure() {
    var hdr = document.getElementById("site-header");
    wrap = hdr ? (hdr.closest(".shopify-section") || hdr) : null;
    var h = wrap ? wrap.offsetHeight : 0;
    if (h) html.style.setProperty("--pt-hdr-h", h + "px");
    return h || 53;
  }
  function tick() {
    if (!band || !document.body.contains(band)) { html.classList.remove("pt-ct-past"); return; }
    var h = measure();
    /* paper as soon as the band's bottom edge is no longer behind the header */
    html.classList.toggle("pt-ct-past", band.getBoundingClientRect().bottom <= h + 24);
  }
  function inkBand() {
    band = document.querySelector("[data-ct-band]");
    tick();
    if (bound) return;
    bound = true;
    window.addEventListener("scroll", tick, { passive: true });
    window.addEventListener("resize", tick);
    if (window.ResizeObserver && wrap) new ResizeObserver(tick).observe(wrap);
  }

  /* ---------- 2 · topic card ---------- */
  function Topics(root) {
    if (root.__ptCt) return;
    root.__ptCt = true;
    var tabs = [].slice.call(root.querySelectorAll('[role="tab"]'));
    var panes = [].slice.call(root.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length) return;
    var cur = Math.max(0, tabs.findIndex ? tabs.findIndex(function (t) { return t.getAttribute("aria-selected") === "true"; }) : 0);
    var fadeT = null;
    function pick(i, focus) {
      tabs.forEach(function (t, k) {
        var on = k === i;
        t.setAttribute("aria-selected", on ? "true" : "false");
        t.tabIndex = on ? 0 : -1;
      });
      if (focus) tabs[i].focus();
      if (i === cur || !panes[i]) return;
      /* dissolve: the old pane stays opaque underneath, the new one fades in on top */
      var prev = panes[cur], next = panes[i];
      /* switched again mid-fade: keep whichever layer is mostly showing as the base, so
         quick clicks never pop a half-faded pane to full strength */
      var base = prev;
      if (fadeT && prev && parseFloat(getComputedStyle(prev).opacity) < 0.5) {
        base = panes.filter(function (p) { return p.classList.contains("is-prev"); })[0] || prev;
      }
      clearTimeout(fadeT);
      panes.forEach(function (p) { if (p !== base) p.classList.remove("is-prev"); });
      if (prev) { prev.classList.remove("is-on"); prev.setAttribute("aria-hidden", "true"); }
      if (base && base !== next) base.classList.add("is-prev");
      if (next === base) {
        /* back to the layer that is still showing underneath: just bring it forward */
        next.classList.remove("is-prev");
        next.classList.add("is-on");
      } else {
        next.classList.add("is-enter", "is-on");
        void next.offsetWidth; /* commit opacity 0 before fading to 1 */
        next.classList.remove("is-enter");
      }
      next.setAttribute("aria-hidden", "false");
      cur = i;
      fadeT = setTimeout(function () { fadeT = null; panes.forEach(function (p, k) { if (k !== cur) p.classList.remove("is-prev"); }); }, 400);
    }
    tabs.forEach(function (t, k) {
      t.addEventListener("click", function () { pick(k); });
      t.addEventListener("keydown", function (e) {
        var d = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[e.key];
        if (e.key === "Home") d = -k; else if (e.key === "End") d = tabs.length - 1 - k;
        if (d === undefined) return;
        e.preventDefault();
        pick((k + d + tabs.length) % tabs.length, true);
      });
    });
    /* theme editor: selecting a topic block shows its pane */
    root.addEventListener("shopify:block:select", function (e) {
      var i = tabs.indexOf(e.target.closest ? e.target.closest('[role="tab"]') : null);
      if (i < 0) i = panes.indexOf(e.target);
      if (i >= 0) pick(i);
    });
  }

  /* ---------- 3 · scroll-in ---------- */
  function reveals(root) {
    var els = [].slice.call((root || document).querySelectorAll(".pt-ct-rv:not(.pt-in)"));
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) { els.forEach(function (e) { e.classList.add("pt-in"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      var shown = 0;
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        el.style.transitionDelay = Math.min(shown, 6) * 60 + "ms";
        shown++;
        el.classList.add("pt-in");
        io.unobserve(el);
        setTimeout(function () { el.style.transitionDelay = ""; }, 800);
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- 4 · warm the photos below the fold ---------- */
  function warm() {
    var imgs = [].slice.call(document.querySelectorAll('.pt-ct img[loading="lazy"]'));
    var k = 0;
    (function next() {
      imgs.slice(k, k + 3).forEach(function (im) { im.loading = "eager"; });
      k += 3;
      if (k < imgs.length) setTimeout(next, 150);
    })();
  }
  function afterLoad() {
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 200); };
    idle(warm, { timeout: 2000 });
  }
  if (document.readyState === "complete") afterLoad();
  else window.addEventListener("load", afterLoad);

  function init(root) {
    inkBand();
    reveals(root);
    [].slice.call((root || document).querySelectorAll("[data-ct-topics]")).forEach(function (el) { new Topics(el); });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { init(); });
  else init();
  /* theme editor: re-init a section when it is added or changed, and recheck the band
     when one is removed */
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
  document.addEventListener("shopify:section:unload", function () { setTimeout(tick, 50); });
})();
